import AuthLayout from '@/layouts/AuthLayout.vue'

export default {
  path: '/',
  component: AuthLayout,
  redirect: '/brand/login',
  children: [
    // {
    //   path: '/',
    //   name: 'Pickl',
    //   component: () => import('@/views/LandingView.vue'),
    //   meta: {
    //       requiresAuth: false,
    //       title: 'Welcome To Pickl',
    //       breadcrumb: 'Landing'
    //   }
    // },
    {
      path: '/brand/login',
      name: 'brand-login',
      component: () => import('@/views/Brand/LoginView.vue'),
      meta: {
        requiresAuth: false,
        title: 'Login | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/reset/password',
      name: 'reset-password',
      component: () => import('@/views/ResetPassword.vue'),
      meta: {
        requiresAuth: false,
        title: 'Reset Password',
        breadcrumb: 'Reset Password'
      }
    },
    {
      path: '/brand/signup',
      name: 'brand-signup',
      component: () => import('@/views/Brand/UpdatedSignup.vue'),
      meta: {
        requiresAuth: false,
        title: 'Signup | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/updated-signup',
      name: 'brand-updated-signup',
      component: () => import('@/views/Brand/UpdatedSignup.vue'),
      meta: {
        name: 'brand-updated-signup',
        requiresAuth: false,
        title: 'Updated Signup',
        breadcrumb: 'Updated Signup'
      }
    },
    {
      path: '/brand/who-do-you-want-to-engage',
      name: 'who-do-you-want-to-engage',
      component: () => import('@/views/Brand/WhoToEngageView.vue'),
      meta: {
        requiresAuth: false,
        title: 'Who do you want to engage | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/want-them-to-do',
      name: 'want-them-to-do',
      component: () => import('@/views/Brand/WantThemToDoView.vue'),
      meta: {
        requiresAuth: false,
        title: 'Want them to do | Brand',
        breadcrumb: 'Login'
      }
    },
  ]
}
